<template>
    <v-container fluid>
        <v-breadcrumbs :items="breadcrumbsItems" class="pa-0 mb-3" large></v-breadcrumbs>
        <!-- 安全警示標示(待處理可就地處理、已處理顯示狀態);無警示不顯示 -->
        <SafetyAlertBlock :alert="safetyAlert" class="rounded-t mb-n1" />
        <Post
            v-if="showPost"
            v-bind:postItem="postItem"
            v-bind:commentList="commentList"
            v-bind:homeworkId="homeworkId"
            v-bind:key="postItem.id" />
    </v-container>
</template>

<script>
import Post from '@/components/console/diary/component/Post.vue'
import SafetyAlertBlock from '@/components/console/diary/component/SafetyAlertBlock.vue'
import { diaryPostServices } from "@/services/diaryPost.js";
import { diaryServices } from "@/services/diary.js";
import { safetyAlertServices } from '@/services/safetyAlert.js';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
export default {
    name: 'diaryPost',
    components: {
        Post,
        SafetyAlertBlock
    },
    data() {
        return {
            breadcrumbsItems: [],
            postId: '',
            homeworkId: '',
            homeworkName: '',
            studentName: '',
            postTitle: '',
            postItem: null,
            commentList: [],
            showPost: false,
            studentId: '',
            safetyAlert: null,
        }
    },
    async created() {
        this.postId = this.$route.params.id;

        console.log('postId', this.postId)

        // 查此篇的安全警示(無警示或無權限回 null,不影響日記瀏覽)
        this.loadSafetyAlert();

        const result = await diaryPostServices.getHomeworkPost(this.postId);
        // this.commentList = result.data.comment;
        if (result.data.comment) {
            dayjs.extend(utc)
            dayjs.extend(timezone)
            const tz = dayjs.tz.guess()
            result.data.comment.forEach((item) => {
                item.create_date = dayjs.utc(item.create_date).tz(tz).format('YYYY-MM-DD HH:mm');
                this.commentList.push(item);
            });
        }
        this.postItem = result.data.post;
        this.homeworkId = result.data.homework_id;
        this.studentId = result.data.post.creator_id;
        this.studentName = result.data.post.user_name;
        this.postTitle = result.data.post.title;
        const diaryHomeworkNameRes = await diaryServices.getHomeworkName(this.homeworkId, {});
        this.homeworkName = diaryHomeworkNameRes.data.name;
        /*
        Notification List
        Journals
        我的心情日記
        Student List
        pj
        發現問題
        */
        this.breadcrumbsItems = [
            {
                text: 'Notification List',
                disabled: false,
                href: `/notification`,
            },
            {
                text: 'Journals',
                disabled: false,
                href: `/diary`,
            },
            {
                text: this.homeworkName,
                disabled: false,
                href: `/diary/homework/${this.homeworkId}`,
            },
            {
                text: 'Student List',
                disabled: false,
                href: `/diary/homework/${this.homeworkId}/student`,
            },

            {
                text: this.studentName,
                disabled: false,
                href: `/diary/homework/${this.homeworkId}/student/${this.studentId}`,
            },
            {
                text: this.postTitle,
                disabled: true,
            },
        ];
        this.showPost = true;
        console.log(result);
    },
    methods: {
        async loadSafetyAlert() {
            try {
                const res = await safetyAlertServices.getByPost(this.postId);
                this.safetyAlert = res.data?.alert ?? null;
            } catch (err) {
                this.safetyAlert = null;
            }
        },
    }
}
</script>

<style scoped></style>